/**
 * Created by huangzhangshu on 2018/6/25
 */
import React, { PureComponent } from 'react';
import './index.less';

export interface TitleProps {
  // 样式前缀
  prefixCls?: string;
  // 显示标题
  text: string;
  // 标题字体颜色
  color?: string;
  // 自定义样式
  style?: React.CSSProperties;
}

export default class Title extends PureComponent<TitleProps> {

  static defaultProps = {
    prefixCls: 'vadp-ui-title',
  }

  render() {
    const { prefixCls } = this.props;
    const { text, color, style = {} } = this.props;
    const lineStyle = color ? { backgroundColor: color } : {};
    return (
      <div className={`${prefixCls}`} style={style}>
        <div className={`${prefixCls}-line`} style={lineStyle} />
        <span className={`${prefixCls}-text`}>{text}</span>
      </div>
    );
  }
}
